<header
  class="sticky top-0 z-40 flex items-center justify-between h-[64px] sm:h-[72px] px-3.5 sm:px-6 lg:px-10 bg-white/95 dark:bg-slate-900/95 backdrop-blur-xl border-b border-slate-100 dark:border-slate-800"
>
  <!-- LEFT: Menu Toggle (Mobile/Desktop) + Logo -->
  <div class="flex items-center gap-2.5 sm:gap-4 lg:gap-8 flex-1 min-w-0">
    <button
      (click)="toggleSidebar.emit()"
      class="hidden lg:flex w-9 h-9 sm:w-10 sm:h-10 items-center justify-center rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-500 dark:text-slate-300 hover:text-slate-900 dark:hover:text-white hover:bg-slate-100 dark:hover:bg-slate-700 transition-all active:scale-95 cursor-pointer shrink-0"
      title="Menu"
    >
      <ng-icon name="menu" size="20" class="sm:hidden"></ng-icon>
    </button>
    <!-- Logo -->
    <div class="flex items-center gap-2 sm:gap-3 group cursor-pointer shrink-0" [class.opacity-0]="isSearchFocused()" [class.pointer-events-none]="isSearchFocused()">
      @if (activeClub()?.logo && activeClub()?.logo !== 'string') {
        <img [src]="activeClub().logo" alt="Logo du Club" class="h-8 sm:h-10 object-contain" />
      } @else {
        <span class="font-head font-extrabold text-lg sm:text-xl tracking-tight text-slate-900 dark:text-white uppercase">
          Gym<span class="text-orange-500 text-2xl sm:text-3xl">o</span>
        </span>
      }
    </div>

    <!-- Backdrop for search -->
    @if (isSearchFocused()) {
      <div
        class="fixed inset-0 bg-slate-900/20 backdrop-blur-sm z-50 animate-fade-in"
        (mousedown)="isSearchFocused.set(false)"
      ></div>
    }
  </div>

  <div class="flex items-center gap-2 sm:gap-3.5 shrink-0">

    <!-- Club Dropdown -->
    <!--@if (clubs().length > 0) {
      <div class="relative w-32 xs:w-40 sm:w-48 lg:w-64">
        <app-dropdown-form
          [options]="clubOptions()"
          [value]="activeClub()?.id"
          (valueChange)="onClubChange($event)"
        ></app-dropdown-form>
      </div>
    } -->

    <!-- Dark Mode Toggle Button -->
    <button
      type="button"
      (click)="toggleTheme()"
      class="w-9 h-9 sm:w-10 sm:h-10 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 flex items-center justify-center text-slate-500 dark:text-slate-300 hover:text-orange-500 dark:hover:text-orange-400 hover:border-orange-500/30 transition-all active:scale-95 cursor-pointer shrink-0"
      [title]="isDark() ? 'Activer le mode clair' : 'Activer le mode sombre'"
      aria-label="Changer de thème"
    >
      <ng-icon [name]="isDark() ? 'sun' : 'moon'" size="18"></ng-icon>
    </button>

    <!-- User Profile Dropdown -->
    <div class="relative">
      <button
        (click)="$event.stopPropagation(); toggleDropdown()"
        class="flex items-center gap-2 sm:gap-3 pl-1.5 pr-2 sm:pr-4 py-1.5 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-[20px] hover:border-brand-500/30 hover:bg-brand-500/5 transition-all group cursor-pointer"
      >
        @if (profile()?.user?.image && profile()?.user?.image !== 'string') {
          <img
            [src]="profile()?.user?.image"
            alt="Avatar"
            class="w-9 h-9 rounded-xl object-cover flex-shrink-0 shadow-lg group-hover:scale-105 transition-all"
          />
        } @else {
          <div
            class="w-9 h-9 rounded-xl bg-gradient-to-br from-brand-600 to-brand-400 flex items-center justify-center font-head font-bold text-xs text-white flex-shrink-0 shadow-lg group-hover:scale-105 transition-all animate-pulse-slow"
          >
            {{ (profile()?.user?.email?.substring(0, 2) || 'US').toUpperCase() }}
          </div>
        }
        <div class="hidden sm:flex flex-col text-left items-start justify-center">
          <span class="font-head font-bold text-xs sm:text-[13px] leading-none text-slate-900 dark:text-white mb-1"
            >{{ profile()?.user?.first_name ? (profile()?.user?.first_name + ' ' + (profile()?.user?.last_name || '')) : (profile()?.user?.email || 'N/A') }}</span
          >
          <span class="text-[9px] sm:text-[10px] text-slate-500 dark:text-slate-400 font-medium uppercase tracking-wider"
            >{{ profile()?.user?.role?.name || (localStorageService.getRole() === 'SUPER_ADMIN' ? 'Super Admin' : (localStorageService.getRole() || 'Manager')) }}</span
          >
        </div>
        <ng-icon
          name="chevron-down"
          size="16"
          class="hidden sm:block text-slate-400 group-hover:text-brand-500 transition-all"
          [class.rotate-180]="isDropdownOpen()"
        ></ng-icon>
      </button>

      <!-- Dropdown menu -->
      @if (isDropdownOpen()) {
        <div
          class="absolute right-0 mt-2 z-50 bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-2xl shadow-xl w-52 py-2 animate-slide-up"
          (click)="$event.stopPropagation()"
        >
          <ul class="text-sm font-medium">
            <li>
              <a 
                [routerLink]="dashboardLink"
               class="flex items-center gap-3 px-4 py-2.5 text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 hover:text-brand-500 transition-colors">
                <ng-icon name="layout-dashboard" size="16"></ng-icon>
                Tableau de bord
              </a>
            </li>
            <li>
              <a 
                [routerLink]="profileLink"
                class="flex items-center gap-3 px-4 py-2.5 text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 hover:text-brand-500 transition-colors">
                <ng-icon name="user" size="16"></ng-icon>
                Profil
              </a>
            </li>
            <li>
              <a 
                [routerLink]="settingLink"
                class="flex items-center gap-3 px-4 py-2.5 text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 hover:text-brand-500 transition-colors">
                <ng-icon name="settings" size="16"></ng-icon>
                Paramètres
              </a>
            </li>
            <li>
              <button
                type="button"
                (click)="toggleTheme()"
                class="flex items-center justify-between w-full px-4 py-2.5 text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 hover:text-brand-500 transition-colors border-b border-slate-50 dark:border-slate-800 cursor-pointer text-left"
              >
                <div class="flex items-center gap-3">
                  <ng-icon [name]="isDark() ? 'sun' : 'moon'" size="16"></ng-icon>
                  <span>{{ isDark() ? 'Mode clair' : 'Mode sombre' }}</span>
                </div>
                <span class="text-[10px] px-2 py-0.5 rounded-full bg-slate-100 dark:bg-slate-800 text-slate-500 dark:text-slate-400 font-semibold">
                  {{ isDark() ? 'Sombre' : 'Clair' }}
                </span>
              </button>
            </li>
            @if (!pwaService.isStandalone() && (pwaService.canInstall() || pwaService.isIOS())) {
              <li>
                <button
                  (click)="pwaService.openInstallPrompt(); isDropdownOpen.set(false)"
                  class="flex items-center gap-3 w-full px-4 py-2.5 text-orange-600 hover:bg-orange-50 dark:hover:bg-orange-950/30 transition-colors text-left font-medium border-b border-slate-50 dark:border-slate-800 cursor-pointer"
                >
                  <ng-icon name="plus" size="16"></ng-icon>
                  Installer l'application
                </button>
              </li>
            }
            <li>
              <button
                (click)="toggleModal()"
                class="flex items-center gap-3 w-full px-4 py-2.5 text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-950/30 transition-colors text-left font-semibold cursor-pointer"
              >
                <ng-icon name="log-out" size="16"></ng-icon>
                Déconnexion
              </button>
            </li>
          </ul>
        </div>
      }
    </div>
  </div>
</header>

<app-modal [isOpen]="showModal()" title="Déconnexion" (close)="toggleModal()">
  <div class="flex flex-col gap-4">
    <p class="text-base sm:text-lg font-semibold text-slate-900 dark:text-white">Se déconnecter</p>
    <p class="text-xs sm:text-sm text-slate-500 dark:text-slate-400">Êtes-vous sûr de vouloir vous déconnecter ?</p>
    <div class="flex justify-end gap-3 mt-4">
      <app-button-form
        label="Annuler"
        variant="outline"
        type="button"
        size="md"
        (onClick)="toggleModal()"
      ></app-button-form>
      <app-button-form
        label="Oui, se déconnecter"
        type="button"
        size="md"
        (onClick)="onLogout()"
      ></app-button-form>
    </div>
  </div>
</app-modal>
